export function StaticsFinal(target: any): void {
	Object.freeze(target);
}

@StaticsFinal
export class Constants {
	static readonly LoginRouteUrl: string = '/login';
	static readonly AdminRouteUrl: string = '/admin';
	static readonly KpiChartColors: string[] = ['#36455a', '#3b6eb9', '#f7596f', '#fe9c49', '#90b756', '#129484', '#163f7c', '#8654ae', '#ff7958', '#f1be48', '#65ae68', '#207585'];
	static readonly KpiChartFontFamily: string = 'lato';
	static readonly HuronAcceleratorsAbbreviation = 'HAP';
  	static readonly LEMFullName = 'LEADER EVALUATION MANAGER';
  	static readonly PCMFullName = 'PATIENT CALL MANAGER';
	static readonly emailRegEx = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
	static readonly phoneRegEx = new RegExp(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im);
	static readonly SsoNameRegEx = new RegExp(/^[a-zA-Z0-9@_\-.()\\\/\*]*$/);

  	static readonly LEMAbbreviation = 'LEM';
  	static readonly PCMAbbreviation = 'PCM';
  	static readonly VMAbbreviation = 'VM';
  	static readonly CPIAbbreviation = 'CPI';
	static readonly DMSAbbreviation = 'DMS';
	static readonly CBMAbbreviation = 'CBM';
  	static readonly HDVAbbreviation = 'HDV';
  	static readonly RCIAbbreviation = 'RCI';
	static readonly HCREAbbreviation = 'HCRE';
  	static readonly HEPAAbbreviation = 'HEPA';

  	static readonly ClientUpsertError = 'An error occurred during client synchronization.';
	static readonly OrganizationSaveError = 'An error occurred during client/organization data synchronization.';
	static readonly Synced = 'Synced';
	static readonly emptyString = '';
	static readonly Failed = 'Failed';
	static readonly ValidationFailure = 'You must enter values for all required fields before saving.';
	static readonly ValidationFailureLEMPCM = 'You must enter values for all required fields before saving for';
	static readonly SaveSuccess = 'Your changes were successfully saved';
	static readonly CoachImpersonation = 'Coach Impersonation';
	static readonly GlobalSettingDuplicateKey = 'Key is already exists, please provide different key.';
	static readonly NLogPatternErrorMessage = 'Pattern is required.';
	static readonly NLogMinLevelErrorMessage = 'Min Level is required.';
	static readonly NLogMaxLevelErrorMessage = 'Max Level is required.';
	static readonly NLogMaxLevelSelectionMessage = 'Max level must be greater than or equal to the min level.';
	static readonly DepartmentNameErrorMessage = 'Name is required.';
	static readonly JobTitleErrorMessage = 'Job Title Name is required.';
	static readonly ImportFinishedMessage ='Data import will continue in the background. You may leave this page and return to it later to check the status of your import.';
	static readonly SecurityQuestionSaveSuccess = "Your changes to security questions were successfully saved.";
	static readonly SecurityQuestionDuplicate = "You cannot have duplicate security questions.";
	static readonly ChangePasswordSaveSuccess = "Your password was successfully changed.";
	static readonly PasswordNotMatch = "New password does not match confirm password.";
	static readonly PasswordDifferent = "New password must be different from the current password.";
	static readonly BasicInfoClientTabName = "Basic Information";
}

@StaticsFinal
export class UserRoleConstants {
	static readonly User = 'User';
	static readonly HuronAdministrator = 'HuronAdministrator';
	static readonly CorporationAdministrator = 'CorporationAdministrator';
	static readonly HuronSupport = 'HuronSupport';
	static readonly CoachImpersonate = 'CoachImpersonate';
	static readonly UserAdministrator = 'UserAdministrator';
	static readonly ClientAdministrator = 'ClientAdministrator';
	static readonly RootAdmin = 'RootAdmin';
}

@StaticsFinal
export class LoginMethodSettingConstants {
	static readonly None = 'None';
	static readonly LDAP = 'LDAP';
	static readonly WSFed = 'WSFed';
	static readonly SAML2P = 'SAML2P';
}

@StaticsFinal
export class UserStatusConstants {
	static readonly Active = 'Active';
	static readonly Inactive = 'Inactive';
	static readonly Locked = 'Locked';
	static readonly Dormant = 'Dormant';
}

@StaticsFinal
export class CorporationConstants {
	static readonly MaxPasswordLength: number = 300;
}

interface IUserRole {
	roleId: number;
	name: string;
}

export const userRoles: Array<IUserRole> = Array(
	{ roleId: 1, name: UserRoleConstants.HuronAdministrator },
	{ roleId: 2, name: UserRoleConstants.CorporationAdministrator },
	{ roleId: 3, name: UserRoleConstants.User },
	{ roleId: 4, name: UserRoleConstants.HuronSupport },
	{ roleId: 5, name: UserRoleConstants.CoachImpersonate },
	{ roleId: 6, name: UserRoleConstants.UserAdministrator },
	{ roleId: 7, name: UserRoleConstants.ClientAdministrator }
);

// MinMaxLog values for dropdown in Logging screen inside RootAdmin menu
export const minMaxLevels: MinMaxLogLevels[] = [{
	"name": "Trace",
	"value": 0,
}, {
	"name": "Debug",
	"value": 1,
}, {
	"name": "Info",
	"value": 2,
}, {
	"name": "Warn",
	"value": 3,
}, {
	"name": "Error",
	"value": 4,
}, {
	"name": "Fatal",
	"value": 5,
}];

export class MinMaxLogLevels {
	name: string;
	value: number;
}
